import React, { FC, useState } from 'react';
import useSessionChecking from '../../hooks/useSessionChecking';
import { BackMappings } from '../../utils/BackMappings';
import { StorageHelper } from '../../utils/StorageHelper';
import { SystemManager } from '../../utils/SystemManager';

const Revistas: FC = () => {
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.REVISTA);
  useSessionChecking(BackMappings.REVISTA, setGoOn, goOn);

  if (goOn) {
    return SystemManager.getSystem('revistas');
  }
  return <></>;
};

export default Revistas;
